import { useCallback } from 'react'
import { getGroups } from '../crud/groups.crud'
import useApiControls from './useApiControls'

const INITIAL_DATA = []

const useGroupsFetch = () => {
  const parseData = useCallback(
    (responseData) => responseData?.map((item) => ({ ...item.rawDataFlat, type: item.type })),
    [],
  )

  const { callApi, loading, error, data, success } = useApiControls({
    api: getGroups,
    initialData: INITIAL_DATA,
    parseData,
  })

  return {
    fetchGroups: callApi,
    isFetchingGroups: loading,
    hasFetchedGroups: success || Boolean(error),
    errorFetchingGroups: error,
    groups: data,
  }
}

export default useGroupsFetch
